export default __webpack_public_path__ + "static/media/ic_mim_24.8e7c7fff.svg";